module.exports = __webpack_public_path__ + "img/75ccee2.jpg";